import React, { useContext, useEffect, useState } from 'react'
import { Layout, Row, Col, Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import { NavView } from '../../components/NavView';
import { AppContext, useApiContext } from '../../util/context';
import { MenuTab } from '../../components/MenuTab';
import { listHazardActionsByAssignedTo, listHZDCardsCreatedBy } from '../../util/myQueries';
import './ActionTracker.css'
import { HazardATContainerView } from '../../components/ActionTracker/Hazard/HazardATContainerView';
import ErrorBoundary from '../../util/ErrorBoundary';

const { Content } = Layout;

export const ActionTrackerView = ({appProps}) => {
    const { StyledDiv, userData} = useContext(AppContext);
    const { client } = useApiContext();
    const [current, setCurrent] = useState('myactions');
    const [myActions, setMyActions] = useState([]);
    const [assignedActions, setAssignedActions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [refetchData, setRefetchData] = useState(false);

    async function fetchAllHazardActions() {
        const fullName = userData.given_name + " " + userData.family_name;
        let allItems = [];
        let nextToken = null;
      
        do {
          const response = await client.graphql({
            query: listHZDCardsCreatedBy,
            variables: { createdBy: fullName,limit: 300, nextToken },
          });
          allItems = [...allItems, ...response.data.listHazards.items];
          nextToken = response.data.listHazards.nextToken;
        } while (nextToken);
        return allItems;
    }

    async function fetchAllHazardActionsByAssignedTo() {
        const fullName = userData.given_name + " " + userData.family_name;
        let allItems = [];
        let nextToken = null;
      
        do {
          const response = await client.graphql({
            query: listHazardActionsByAssignedTo,
            variables: { assignedTo: fullName, limit: 300, nextToken },
          });
          
          allItems = [...allItems, ...response.data.listHazardActions.items];
          nextToken = response.data.listHazardActions.nextToken;
        } while (nextToken);
        return allItems;
    }

    useEffect(() => {
        let mounted = true;

        const fetchData = async () => {
            try {

                //const fullName = userData.given_name + " " + userData.family_name;
                /* if(fullName === "Dillon Raymond"){
                    const cards = await fetchAllHazardActions();
                    if (cards){
                        let myactions = [];
                        cards.forEach((card) => {
                            if (card.actions.items) {
                                card.actions.items.forEach((action) => {
                                    action.cardID = card.id;
                                    action.dateObserved = card.dateObserved;
                                    action.HZDID = card.HZDID;
                                    action.location = card.location;
                                    myactions.push(action);
                                });
                            }
                        });

                        if (mounted) {
                            setMyActions(myactions);
                        }
                    }

                    const actions = await fetchAllHazardActionsByAssignedTo();
                    if (actions){
                        let assignedActions = [];
                        actions.forEach((action) => {
                            action.dateObserved = action.Hazard.dateObserved;
                            action.HZDID = action.Hazard.HZDID;
                            action.location = action.Hazard.location;
                            assignedActions.push(action);
                        });
                    }

                    if (mounted) {
                        setAssignedActions(assignedActions);
                    }
                }else{

                    const cards = await client.graphql({
                        query: listHZDCardsCreatedBy,
                        variables: { createdBy: fullName, limit: 1000 },
                    });

                    if (cards){
                        let myactions = [];
                        cards.data.listHazards.items.forEach((card) => {
                            if (card.actions.items) {
                                card.actions.items.forEach((action) => {
                                    action.cardID = card.id;
                                    action.dateObserved = card.dateObserved;
                                    action.HZDID = card.HZDID;
                                    action.location = card.location;
                                    myactions.push(action);
                                });
                            }
                        });

                        if (mounted) {
                            setMyActions(myactions);
                        }
                    }

                    const actions = await client.graphql({
                        query: listHazardActionsByAssignedTo,
                        variables: {
                            assignedTo: fullName,
                            limit: 1000
                        }
                    });

                    if (actions) {
                        let assignedActions = [];
                        actions.data.listHazardActions.items.forEach((action) => {
                            action.dateObserved = action.Hazard.dateObserved;
                            action.HZDID = action.Hazard.HZDID;
                            action.location = action.Hazard.location;
                            assignedActions.push(action);
                        });
            
                        if (mounted) {
                            setAssignedActions(assignedActions);
                        }
                    }
                } */
                
                const cards = await fetchAllHazardActions();
                if (cards){
                    let myactions = [];
                    cards.forEach((card) => {
                        if (card.actions.items) {
                            card.actions.items.forEach((action) => {
                                action.cardID = card.id;
                                action.dateObserved = card.dateObserved;
                                action.HZDID = card.HZDID;
                                action.location = card.location;
                                myactions.push(action);
                            });
                        }
                    });

                    if (mounted) {
                        setMyActions(myactions);
                    }
                }

                const actions = await fetchAllHazardActionsByAssignedTo();
                if (actions){
                    let assignedActions = [];
                    actions.forEach((action) => {
                        
                        action.dateObserved = action.Hazard.dateObserved;
                        action.HZDID = action.Hazard.HZDID;
                        action.location = action.Hazard.location;
                        assignedActions.push(action);
                    });

                    if (mounted) {
                        setAssignedActions(assignedActions);
                    }
                }

                
            } catch (error) {
                console.log('Error fetching data:', error);
                if (mounted) setError(true);
            } finally {
                if (mounted) setLoading(false);
            }
        };

        if(mounted && userData){
            setLoading(true)
            fetchData();
        }

        return () => {
            mounted = false;
        };
    }, [userData, refetchData]);

    return (
        <Layout className="layout">
            <Content style={{ padding: "0", backgroundColor: "white" }}>
                <NavView landing={false} selection="actiontracker" appProps={appProps}/>

                <Row>
                    <Col
                        span={2}
                        className="homeHazardMenu"
                    >
                        <MenuTab location="actiontracker" appProps={appProps} StyledDiv={StyledDiv} />
                    </Col>

                    <Col
                        xl={{span: 22}}
                        lg={{span: 24}}
                        md={{span: 24}}
                        sm={{span: 24}}
                        xs={{span: 24}}
                        style={{
                            height: "91dvh",
                            marginTop: "9dvh"
                        }}
                    >
                        {loading && (
                            <Row
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                                    <Spin indicator={<LoadingOutlined style={{ fontSize: 50 }} spin />} spinning={loading}></Spin>
                                </div>
                            </Row>
                        )}

                        {error && (
                            <Row
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    className="errorText"
                                ><StyledDiv>Data fetch failed, please try again later.</StyledDiv></div>
                            </Row>
                        )}

                        {!loading && !error && <>
                            <ErrorBoundary>
                                <HazardATContainerView
                                    data={
                                        current === 'myactions' ? myActions :
                                        assignedActions
                                    } 
                                    client = {client} 
                                    current = {current} 
                                    setCurrent = {setCurrent}
                                    isRep = {false}
                                    setRefetchData = {setRefetchData}
                                    refetchData = {refetchData}
                                />
                            </ErrorBoundary>
                            
                            
                        </>}
                    </Col>
                </Row>
            </Content>
        </Layout>
    )
}